export function getRuleForField(validationRules, field) {
    // for nested properties this will be passed done as Entity.ClientName but needs to be in array like ['Entity', 'ClientName']
    let propertyNames = field.split('.')
    if (field.length === 1) {
        propertyNames = [field]
    }

    // validationRules loaded from the server will have a PropertyNames array against it so find where the array is equal to array made from the field name passed in
    return validationRules.find(validationRule => arraysEqual(validationRule.PropertyNames.$values, propertyNames))
}

export function getRuleForProperty(validationRules, fieldNames) {
  if (!validationRules || !fieldNames || fieldNames.length === 0) return {};
  // If validationRules is an array, find the rule object for the field
  if (Array.isArray(validationRules)) {
    const propertyNames = fieldNames[0].split('.');
    return validationRules.find(
      rule => rule.PropertyNames && arraysEqual(rule.PropertyNames.$values, propertyNames)
    ) || {};
  }
  // If validationRules is a simple object, use the key
  const fieldName = fieldNames[0];
  return validationRules[fieldName] || {};
}

function arraysEqual(a, b) {
    if (a === b)  {
        return true
    }
    if (a == null || b == null) {
        return false
    }
    if (a.length !== b.length) {
        return false
    }

    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) {
            return false
        }
    }
    return true
}

function formatDate(date) {
    return date.substring(0,10);
}

export function validateFromRule(validationRule, value, hasSavedFile) {
    let validationResult = {}

    // handle file differently as we are using a ref to read if files have been uploaded
    if (validationRule.IsFile) {
        let hasFiles = value && value.current && value.current.state.files && value.current.state.files.length > 0
        if (validationRule.IsRequired && !hasFiles && !hasSavedFile) {
            validationResult.error = validationRule.DisplayName + ' is required'
        }
        if (hasFiles) {
            for (let i = 0; i < value.current.state.files.length; i++) {
                let file = value.current.state.files[i]
                if (validationRule.PatternToCheck  && value && RegExp(validationRule.PatternToCheck).test(file.name) === false) {
                    validationResult.error = validationRule.PatternErrorMessage
                }
                if(file.size > 10485760){
                     validationResult.error = "Stat Dec File is too large. Must be less that 10mb"
                }
            }
        }
    } else if (validationRule.IsRequired && !value) {
        validationResult.error = validationRule.DisplayName + ' is required'
    }
    if (validationRule.MinLength && value && value.length < validationRule.MinLength) {
        validationResult.error = validationRule.DisplayName + ' must have a mininum of ' + validationRule.MinLength + ' characters'
    }
    if (validationRule.MaxLength  && value && value.length > validationRule.MaxLength) {
        validationResult.error = validationRule.DisplayName + ' must have a maximum of ' + validationRule.MaxLength + ' characters'
    }   
    if (validationRule.MinValue && value && value < validationRule.MinValue) {
        validationResult.error = validationRule.DisplayName + ' must have a mininum value of ' + validationRule.MinValue 
    }
    if (validationRule.MaxValue  && value && value > validationRule.MaxValue) {
        validationResult.error = validationRule.DisplayName + ' must have a maximum value of ' + validationRule.MaxValue 
    } 
    // TODO: Need to check if this can be done or needs to be done on blur    
    if (validationRule.PatternToCheck  && value && RegExp(validationRule.PatternToCheck).test(value) === false) {
        validationResult.error = validationRule.PatternErrorMessage
    }
    if (validationRule.MinDate && value && value < validationRule.MinDate) {
        validationResult.error = validationRule.DisplayName + ' must be after '+ formatDate(validationRule.MinDate)
    }  
    if (validationRule.MaxDate && value && value > validationRule.MaxDate) {
        validationResult.error = validationRule.DisplayName + ' must be before '+ formatDate(validationRule.MaxDate)
    } 
    // if there are no errors then add success. this will clear any validation messages on the screen for the field being validated
    if (!validationResult.error) {
        validationResult.success = ""
    }
    return validationResult
}


// WEBPACK FOOTER //
// ./src/js/validation.js